import React, { Component } from 'react';
import axios from '../../../axios-ns';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Aux from '../../../hoc/Aux';

class Messages extends Component {
    state = {
        messages: null,
        loading: true
    }

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/audio/messages/TO_EVALUATE', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    let messages = response.data.map(m => {
                        m.answer = '';
                        return m;
                    });
                    this.setState({ messages: messages, loading: false });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("error");
                })
        }
    }

    handleSubmit = (event, message) => {
        event.preventDefault();

        axios.put('/protected/audio/message', message, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                let messages = this.state.messages.filter(m => m.studentQuestionCode != message.studentQuestionCode);
                this.setState({ ...this.state, messages: messages })
            })
            .catch(err => {
                alert("Wiadomość nie mogła zostać wysłana");
            })
    }

    handleChange = (event, studentQuestionCode) => {
        let messages = this.state.messages.map(m => {
            if (m.studentQuestionCode === studentQuestionCode) {
                m.answer = event.target.value;
            }

            return m;
        })
        this.setState({ ...this.state, messages: messages });
    }

    render() {
        let messages = null;

        if (this.state.messages) {
            if (this.state.messages.length === 0) {
                messages = <p>Brak nowych wiadomości</p>
            } else {
                messages = this.state.messages.filter(m => {
                    if (m.contextMessages == null) {
                        return true;
                    } else if (m.contextMessages != null && m.contextMessages.length > 0 && m.studentQuestionCode == m.contextMessages[m.contextMessages.length - 1].studentQuestionCode) {
                        return true;
                    } else {
                        return false;
                    }
                }).map(m => {
                    let material = (<Card style={{padding: '5px'}} key={m.studentQuestionCode}>
                        <p>Produkt: <b>{m.productName}</b></p>
                        <p>Rozdział: <b>{m.chapterNumber + ' ' + m.chapterName}</b></p>
                        <p>Materiał: <b title={m.materialDescription}>{m.materialTitle}</b></p>
                    </Card>);

                    let context = m.contextMessages.map(cm => {
                        let inContext = cm.studentQuestionCode === m.studentQuestionCode ? <b>*</b> : null;
                        return (
                            <Card style={{ padding: '5px' }} key={cm.studentQuestionCode + "__"}>
                                {inContext}
                                <b style={{ color: 'orange' }}>Q:</b> {cm.question}  <span style={{ color: 'grey', fontSize: '8px' }}><br />{cm.questionDate}</span><br />
                                <b>A:</b> {cm.answer ? cm.answer : 'brak'} <span style={{ color: 'grey', fontSize: '8px' }}><br />{cm.answerDate ? cm.answerDate : 'brak'}</span><br />
                            </Card>
                        )
                    })
                    return (
                        <Card key={m.question}>
                            <CardContent>
                                <b>Kontekst:</b><br />
                                {material}
                                {context}
                                <hr />
                                <b style={{ color: 'orange' }}>Pytanie:</b> {m.question}  <span style={{ color: 'grey', fontSize: '8px' }}><br />{m.questionDate}</span><br />
                                <Card style={{ padding: '10px' }}>
                                    <form onSubmit={(event) => this.handleSubmit(event, m)}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            label="Twoja odpowiedź"
                                            multiline
                                            rowsMax="4"
                                            value={m.answer}
                                            onChange={(event) => this.handleChange(event, m.studentQuestionCode)}
                                            margin="normal"
                                            helperText="Opisz proszę możliwie precyzyjnie swoją odpowiedź."
                                        />
                                        <Button variant="outlined" type="submit" color="primary">Wyślij</Button>
                                    </form>
                                </Card>

                            </CardContent>
                        </Card>
                    )
                });
            }
        }

        let view = null;

        if (this.state.loading) {
            view = <Spinner />
        } else {
            view = (<Aux>
                {messages}
            </Aux>);
        }

        return (view);

    };
}

export default Messages;